import _ from 'lodash';
import { ENDPOINT } from '../../constants/endpoint.js';

const state = {
  loading: false,
  mpProvinces: [],
};
const token =
  'eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIyIiwic2NwIjoidXNlciIsImF1ZCI6bnVsbCwiaWF0IjoxNjAwNzA2NTcyLCJleHAiOjI3MjY2ODA3MjM0NTcyLCJqdGkiOiIxNGNjNzI3Ny1kODg4LTQwZGUtODZkZi1iNDkzY2RhMzYzNTgifQ.1uhBK4cq-QhM_w21B2iPQLrPWB6kpf5l-fJt4iROO6E';

const actions = {
  async getMpProvincesAll(context) {
    const url = ENDPOINT.MP_PROVINCES;
    $.ajax({
      url: url,
      type: 'GET',
      beforeSend: (xhr) => {
        xhr.setRequestHeader('Authorization', `Bearer ${token}`);
      },
      success: (result) => {
        const data = result;
        context.commit('SET_MP_PRTVINCES_ALL', data);
      },
      error: (e) => {
        // error
        console.log('e is ', e);
      },
      complete: () => {
        // complete
      },
    });
  },
};

const mutations = {
  SET_MP_PRTVINCES_ALL(state, payload) {
    state.mpProvinces = payload;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
